"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ARTWORK_FIT_MODE = void 0;
exports.ARTWORK_FIT_MODE = {
    CONTAIN: 'CONTAIN',
    COVER: 'COVER'
};
//# sourceMappingURL=artworkFitMode.js.map